<template>
    <div class="OrderTable" v-loading="loading">
        <div class="top_bar" style="margin-bottom: 20px">
            <div class="case" style="text-align: right">
                <div class="case-title">
                    <img class="case-title_icon" src="@/assets/images/icon_lb@2x.png" alt />
                    <div class="case-title_max">
                        订单列表<span style="color: #ff5757; margin-left: 5px">({{ pages.total }})</span>
                    </div>
                </div>
            </div>
            <!-- <div class="case" style="text-align: right">
                <GardenSlwct :tab-data="tabData" :activeIndex="activeIndex" width="120px" border-radius="40px"
                    @tabAction="tabAction">
                </GardenSlwct>
            </div> -->
            <div>
                <el-button size="small" type="success" icon="el-icon-download" @click="exportExcel">导出Excel</el-button>
            </div>
        </div>
        <div v-if="this.pages.total > 0">
            <div v-for="(item, index) in orderTableList" :key="index" class="order_list">
                <div class="line_top"></div>
                <div class="table_title" :style="{
                    background:
                        item.isOpenMatrix && item.isOpenMatrix !== '--'
                            ? '#FEF3E2'
                            : '#EAF1FF',
                }">
                    <div class="left">
                        <div style="margin-left: 0">
                            <div>{{ index + 1 }}</div>
                        </div>
                        <div v-if="item.recycleWay || item.expressChannel">
                            <span class="sty" style="color: #fff"
                                v-if="item.recycleWay === '02' && item.channel == 'Store'">
                                独立回收
                            </span>

                            <span class="sty" style="color: #fff"
                                v-if="item.recycleWay === '01' && item.channel == 'Store'">
                                以旧换新
                            </span>

                            <span class="sty" v-if="item.expressChannel == '01'"
                                style="background: #7dc165; color: #fff">繁星物流</span>
                            <span class="sty" style="background: #84c0ff; color: #fff"
                                v-if="item.expressChannel == '02'">线下物流</span>
                        </div>
                        <div style="display: flex; align-items: center; margin-left: 30px">
                            <span class="order-nice" v-if="item.isNiceBiz == true">靓机订单</span>
                            <span>订单号：</span>
                            <span :id="'orderNo' + index">{{ item.orderNo }}</span>
                            <span class="copy" @click="copy('orderNo' + index)" :style="{
                                background:
                                    item.isOpenMatrix && item.isOpenMatrix !== '--'
                                        ? '#4C84FF'
                                        : '#FF6600',
                            }">复制</span>
                        </div>
                        <div>
                            <span>下单时间：</span>
                            <span>{{ item.orderTime }}</span>
                        </div>
                        <div class="flex">
                            <span>询价商家：</span>
                            <!-- <span>{{ item.companyName }}</span> -->
                            <el-tooltip :content="item.companyName" placement="top">
                                <span>{{ item.companyName }}</span>
                            </el-tooltip>
                        </div>
                        <div style="font-size: '14px'; font-family: FZLanTingHei-DB-GBK" v-if="(item.isOpenMatrix && item.isOpenMatrix !== '--') && item.matrixOrderNo &&
                            item.matrixOrderNo !== '--'">
                            <span style="color: #0981ff">矩阵订单号：</span>
                            <a v-if="item.matrixOrderNo === '--' || !item.matrixOrderNo"
                                style="color: #0981ff; font-family: FZLanTingHei-DB-GBK">--</a>
                            <a v-else style="
                  text-decoration: underline;
                  cursor: pointer;
                  color: #0981ff;
                  font-size: 14px;
                  font-family: FZLanTingHei-DB-GBK;
                " :href="`/RecallOrder/Details?type=edit&id=${item.matrixOrderNo}`" target="_blank">{{
                    item.matrixOrderNo }}</a>
                        </div>
                        <!-- 不是矩阵订单,但是外部渠道，显示外部订单号，不是矩阵订单，不是外部渠道，不显示 -->
                        <!-- v-else-if="(item.outType && item.outType !== '--') && (!item.isOpenMatrix || item.isOpenMatrix === '--')"-->
                        <div v-if="
                            item.orderNoOneline &&
                            item.orderNoOneline !== '--'
                        " class="flex" style="
                font-size: '14px';
                color: #ffa11b;
                font-family: FZLanTingHei-DB-GBK;
              ">
                            <span style="color: #ffa11b">{{ item.outMake }}订单号：</span>
                            <span v-if="!item.orderNoOneline || item.orderNoOneline === '--'"
                                style="font-size: 14px; color: #ffa11b">--</span>
                            <span v-else-if="
                                item.orderNoOneline &&
                                item.orderNoOneline !== '--' &&
                                item.outType !== 'fx'
                            " style="font-size: 14px; color: #ffa11b">{{ item.orderNoOneline }}</span>
                            <a v-else :href="`/RecallOrder/Details?type=edit&id=${item.orderNoOneline}`" style="
                  text-decoration: underline;
                  cursor: pointer;
                  font-size: 14px;
                  color: #ffa11b;
                  font-family: FZLanTingHei-DB-GBK;
                " target="_blank">{{ item.orderNoOneline }}</a>
                        </div>



                    </div>
                </div>
                <div class="table_list">
                    <el-table :data="[item]" border style="width: 100%" id="excelOrder">
                        <el-table-column prop="name" label="旧机图片" align="center" width="100px">
                            <template slot-scope="{ row }">
                                <div class="images-box" v-if="row.images && row.images.length > 0">
                                    <img :src="row.images[0].img" alt="" />
                                    <span @click="openImgBox(row)" class="text-down">共{{ row.images.length }}张</span>
                                </div>
                                <div v-else>暂无图片</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phoneName" label="机型" align="center" width="150px">
                            <template slot-scope="{ row }">
                                <p>{{ row.phoneName == "--" ? "" : row.phoneName }}</p>
                                <p> {{ row.phoneMemory == "--" ? " " : row.phoneMemory }}
                                    <span v-if="row.phoneMemory !== '--'">+</span>
                                    {{ row.phoneStorage == "--" ? "" : row.phoneStorage }}
                                </p>
                                <span v-if="
                                    row.phoneName == '--' &&
                                    row.phoneMemory == '--' &&
                                    row.phoneStorage == '--'
                                ">--</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="imei" label="旧机串号" align="center" width="130px">
                            <template slot-scope="{ row }">
                                <div>{{ row.imei || "--" }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="quoteTime" label="报价时间" align="center" width="130px">
                            <template slot-scope="{ row }">
                                <span>{{ row.quoteTime || "--" }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="报价记录" width="100px" prop="quoteNum" align="center">
                            <template slot-scope="{ row }">
                                <span style="color: #0981ff; cursor: pointer; text-decoration: underline"
                                    @click="openStoreList(row)">{{ row.quoteNum
                                    }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="报价金额" width="100px" prop="originalQuotePrice" align="center">
                            <template slot-scope="{ row }">
                                <span>￥{{ row.originalQuotePrice
                                    }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单状态" width="100px" prop="phoneName" align="center">
                            <template slot-scope="{ row }">
                                <span v-if="row.state == '00'">待确认</span>
                                <span v-if="row.state == '01'">未绑码</span>
                                <span v-if="row.state == '02'">待支付（未绑码）</span>
                                <span v-if="row.state == '03'">已绑码</span>
                                <span v-if="row.state == '04'">已收货</span>
                                <span v-if="row.state == '05'">降价收货（已收货）</span>
                                <span v-if="row.state == '10'">已取消</span>
                                <span v-if="row.state == '20'">已作废</span>
                                <span v-if="row.state == '30'">已退回</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="开机情况" width="130px" prop="openMachineCondition" align="center">
                            <template slot-scope="{ row }">
                                <span>{{ row.openMachineCondition }}</span>
                                <!-- <span v-if="row.openMachineCondition == 'canStart'">正常开机</span>
                                <span v-if="row.openMachineCondition == 'unStart'">无法开机</span>
                                <span v-if="row.openMachineCondition == 'brand-new'">全新机</span>
                                <span v-if="row.openMachineCondition == 'elderly'">功能机/老年机</span> -->
                                <p style="color: #0981ff; cursor: pointer; text-decoration: underline"
                                    @click="getFunction(row.orderNo, row.outType)">
                                    验机报告</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="sku校验" width="130px" prop="openMachineCondition" align="center">
                            <template slot-scope="{ row }">
                                <span v-if="row.skuValidType == '00'">无需校验</span>
                                <span v-if="row.skuValidType == '01'">校验机型</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="sku比对" width="130px" prop="openMachineCondition" align="center">
                            <template slot-scope="{ row }">
                                <p v-if="row.modelCompare == '00'">未识别</p>
                                <p v-if="row.modelCompare == '01'">机型一致</p>
                                <p v-if="row.modelCompare == '02'" style="color: rgb(255, 104, 123);">机型不一致</p>
                                <p @click="seeSkuDetail(row)"
                                    style="color: rgb(9, 129, 255);cursor: pointer;text-decoration: underline;"
                                    v-if="row.modelCompare !== '00'">比对情况</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="开机亮屏照校验" width="130px" prop="openMachineCondition" align="center">
                            <template slot-scope="{ row }">
                                <p v-if="row.lightScreenValidType == '00'">无需校验</p>
                                <p v-if="row.lightScreenCompare == '00' && row.lightScreenValidType == '01'">未识别</p>
                                <p v-if="row.lightScreenCompare == '01' && row.lightScreenValidType == '01'">校验通过</p>
                                <p v-if="row.lightScreenCompare == '02' && row.lightScreenValidType == '01'">校验失败</p>
                                <p @click="seekjimgResult(row)"
                                    style="color: rgb(9, 129, 255);cursor: pointer;text-decoration: underline;"
                                    v-if="(row.lightScreenCompare == '01' && row.lightScreenValidType == '01') || row.lightScreenCompare == '02' && row.lightScreenValidType == '01'">
                                    识图详情</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="AI识图结果" width="130px" prop="openMachineCondition" align="center">
                            <template slot-scope="{ row }">
                                <div>
                                    <p v-if="row.aiTagNameStr !== '--'" style="color:rgb(255, 104, 123);">{{
                                        row.aiTagNameStr }}</p>
                                    <p v-if="!row.isAiIdentify">未识别</p>
                                    <p v-if="row.isAiIdentify">已识别</p>
                                    <p @click="seeimgResult(row)"
                                        style="color: rgb(9, 129, 255);cursor: pointer;text-decoration: underline;">
                                        查看识图记录</p>
                                </div>
                                <!-- <span>未识别</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="成色等级" width="130px" prop="openMachineCondition" align="center">
                            <template slot-scope="{ row }">
                                <span v-if="row.finenessHealthCode == 'Nice'">靓机</span>
                                <span v-if="row.finenessHealthCode == 'Little_Snow'">小花</span>
                                <span v-if="row.finenessHealthCode == 'Big_Snow'">大花</span>
                                <span v-if="row.finenessHealthCode == 'Out_Burst'">外爆</span>
                                <span v-if="row.finenessHealthCode == 'Inner_Burst'">内爆</span>
                                <span v-if="row.finenessHealthCode == 'Other'">其他</span>
                                <span v-if="row.finenessHealthCode == 'Nice_Lower'">小花靓</span>
                                <p @click="seeMatch(row)"
                                    style="color: rgb(9, 129, 255);cursor: pointer;text-decoration: underline;">
                                    查看匹配情况</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="故障匹配" width="400px" prop="contractDocument" align="center">
                            <template slot-scope="{ row }">
                                <div style="color: rgb(255, 104, 123);" v-if="row.failureNum > 0"><span
                                        style="margin-right: 20px;">{{
                                            row.failureNum }}项:</span><span v-for="(item, index) in row.failureList"
                                        :key="index">{{
                                            index > 0 ?
                                                "|" +
                                                item : item }}</span></div>
                                <div v-else>暂无匹配故障</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="orderPagina">
                <el-pagination background :current-page="pages.currentPage" :page-size="10"
                    layout="total, prev, pager, next,jumper" :total="this.pages.total" class="el-pagination-c"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
        <div style="
        width: 100%;
        text-align: center;
        padding: 80px 0;
        font-size: 24px;
        color: #666666;
        background: white;
        font-weight: bold;
      " v-else>暂无订单~</div>
        <!-- 查看旧机照片 -->
        <el-dialog :close-on-click-modal="false" :width="`${800}px`" title="查看旧机照片" :visible="imgShow" @close="imgClose"
            top="5%">
            <div class="img-box">
                <div class="img-tips-box">
                    <div @click="chooseImages(0)" class="img-tips"
                        :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'">
                        旧机照片
                    </div>
                    <div v-if="this.DialogImgList[1].length > 0" @click="chooseImages(1)" class="img-tips"
                        :class="imgShowOnly ? 'img-tips-default' : 'img-tips-choose'">
                        补拍照片
                    </div>
                    <!--旧机IMEI照片-->
                    <div v-if="this.DialogImgList[2] && this.DialogImgList[2].length > 0" @click="chooseImages(2)"
                        class="img-tips" :class="imgShowOnly ? 'img-tips-default' : 'img-tips-choose'">
                        旧机IMEI照片
                    </div>
                </div>
                <div class="img-show">
                    <div class="imgs-num" v-if="DialogImgList[imgIndex].length > 0">
                        {{ imgShowIndex + 1 }}/{{ DialogImgList[imgIndex].length }}
                    </div>
                    <div class="block">
                        <viewer :images="DialogImgList[imgIndex]">
                            <el-carousel trigger="click" height="80vh" @change="getindex">
                                <el-carousel-item v-for="item in this.DialogImgList[this.imgIndex]" :key="item.imgNo">
                                    <div class="sec_img">
                                        <img :src="item.img" alt="" />
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </viewer>
                    </div>
                    <!-- <LookImg :images="imgList"/> -->
                </div>
            </div>
        </el-dialog>
        <!-- 点击查看一张图片 -->
        <el-image-viewer :zIndex="99999" v-if="showViewer" :on-close="() => {
            showViewer = false;
        }
            " :url-list="imgList" />
        <!-- 初步验机报告 -->
        <el-dialog v-bind="dialogProps" :before-close="() => dialogProps.show = false" :visible.sync="dialogProps.show">
            <div class="test-box">
                <div class="test-info">
                    <Title title="旧机基本情况" />
                    <TestDeviceInfo :datainfo="{
                        machineName: dialogProps.report.machineName,
                        canStartingUp: dialogProps.report.canStartingUp,
                        isNew: dialogProps.report.isNew,
                        isElderlyMachine: dialogProps.report.isElderlyMachine,
                        informationList: dialogProps.report.sku || []
                    }" />
                </div>
                <div class="test-result">
                    <Title title="人工验机项" />
                    <TestTable :isOutMapping="dialogProps.report.isOutMapping"
                        :table-data="dialogProps.report.funcData || []">
                    </TestTable>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="dialogProps.show = false" plain type="primary">关闭</el-button>
            </div>
        </el-dialog>
        <!--sku比对情况弹框-->
        <el-dialog title="sku对比情况" :visible.sync="skuvisible" :close-on-click-modal="false" width="650px"
            @close="skuclose">
            <p style="margin-bottom: 25px;">sku比对结果：<span v-if="skuInfo.modelCompare == '00'">未对比</span><span
                    style="color:#80C269" v-if="skuInfo.modelCompare == '01'">机型一致</span><span style="color: #FF0000;"
                    v-if="skuInfo.modelCompare == '02'">机型不一致</span></p>
            <el-row :gutter="12" style="padding-bottom: 20px;">
                <el-col :span="14">
                    <el-card>
                        <div class="titlefin">识别机型</div>
                        <div style="margin-bottom: 20px;margin-left: 10px;"
                            v-if="skuInfo.phoneName3023 && skuInfo.phoneName3023 !== '--'">{{ skuInfo.phoneName3023 }}
                        </div>
                        <div style="margin-bottom: 20px;margin-left: 10px;"
                            v-if="!skuInfo.phoneName3023 || skuInfo.phoneName3023 == '--'">未知机型</div>
                        <div class="titlefin">订单机型</div>
                        <div style="margin-bottom: 20px;"><span
                                style="margin-right: 20px;color: #0981ff;margin-left: 10px;">{{
                                    skuInfo.phoneName
                                    || '无' }}</span></div>
                        <div style="    background-color: #fff0f2;padding: 5px;" v-if="skuInfo.autoCheckImeiSkuFee&&skuInfo.autoCheckImeiSkuFee!=='--'"><span>平台查询费用:</span><span style="margin-left: 5px;
    color: red;">{{ skuInfo.autoCheckImeiSkuFee }}元/</span><span>单,</span><span>按自动报价单-已校验机型商家收取</span></div>
                        <div style="background-color: #fff0f2;padding: 5px;" v-if="!skuInfo.autoCheckImeiSkuFee||skuInfo.autoCheckImeiSkuFee=='--'">本单不满足扣费条件</div>
                        <!-- <div style="display: flex;margin-bottom: 20px;">
                            <p style="margin-right: 80px;">解析机型:荣耀Magic7 Pro</p>
                            <p>绑定繁星机型：荣耀Magic7 Pro</p>
                        </div>
                        <div style="display: flex;">
                            <p style="margin-right: 90px;">解析容量：16GB+512G</p>
                            <p>绑定繁星容量：16GB+512GB</p>
                        </div> -->
                    </el-card>
                </el-col>
                <!-- <el-col :span="10">
                    <el-card>
                        <div class="title" style="margin-bottom: 58px;">下单信息</div>
                        <div style="margin-bottom: 20px;">机型:<span>荣耀Magic7 Pro</span></div>
                        <div>容量:<span>16GB+512G</span></div>
                    </el-card>
                </el-col> -->
            </el-row>
        </el-dialog>
        <!--识图记录-->
        <el-dialog title="图片识别情况" :visible.sync="imgvisible" :close-on-click-modal="false" width="724px"
            @close="imgclose">
            <div style="margin-bottom: 20px;">
                <el-radio-group v-model="rgType" @change="rgTypechange">
                    <el-radio-button :label="'error'" style="margin-right: 10px;border-radius: 6px;">识别有异常({{
                        aisbObj.exceptionNum
                        }})</el-radio-button>
                    <el-radio-button :label="'right'" style="margin-right: 10px;border-radius: 6px;">识别无异常({{
                        aisbObj.notExceptionNum
                        }})</el-radio-button>
                    <el-radio-button :label="'fault'" style="margin-right: 10px;border-radius: 6px;">识别失败({{
                        aisbObj.errorNum
                        }})</el-radio-button>
                    <el-radio-button :label="'no'" style="border-radius: 6px;">未识别({{ aisbObj.notNum
                        }})</el-radio-button>
                </el-radio-group>
            </div>
            <div class="img_box" style="display: flex;">
                <div class="read_image" ref="readImage">
                    <div class="primary-img" v-for="(item, index) in currentImg" :key="index">
                        <canvas :ref="'myCanvas' + index" :id="'canvas-' + index" @click="seeDetail(item)"></canvas>
                        <div class="labelbox">
                            <p style="margin-bottom: 10px;font-weight: bold;"
                                v-if="rgType !== 'fault' && rgType !== 'no'">识别标签:
                            </p>
                            <p style="margin-bottom: 10px;font-weight: bold;" v-if="rgType == 'fault'">失败原因:</p>
                            <div v-if="rgType == 'right'" style="width: 60px;
height: 20px;
background: rgba(180,188,204,0.22);
border-radius: 4px;font-size: 12px;text-align: center;">
                                无
                            </div>
                            <template v-if="rgType == 'fault'">
                                <div class="myboxtel" v-if="item.errorCause">
                                    <div>
                                        <div style="color: red;">{{ item.errorCause }}</div>
                                    </div>

                                </div>
                            </template>
                            <template v-if="rgType == 'error'">
                                <div v-for="(item, index) in item.tags" :key="index" class="myboxtel">
                                    <div>
                                        <div type="warning" style="margin-bottom: 10px;color: #F59A23;">{{
                                            item.tagName }}</div>
                                    </div>
                                    <div>
                                        <div style="margin-bottom: 10px;">
                                            <span v-if="item.healthCode == 'Little_Snow'">成色等级:<span
                                                    style="color: #ff687b;">小花</span></span>
                                            <span v-if="item.healthCode == 'Big_Snow'">成色等级:<span
                                                    style="color: #ff687b;">大花</span></span>
                                            <span v-if="item.healthCode == 'Out_Burst'">成色等级:<span
                                                    style="color: #ff687b;">外爆</span></span>
                                            <span v-if="item.healthCode == 'Inner_Burst'">成色等级:<span
                                                    style="color: #ff687b;">内爆</span></span>
                                            <span v-if="item.healthCode == 'Other'">成色等级:<span
                                                    style="color: #ff687b;">其他</span></span>
                                            <span v-if="item.healthCode == 'Nice'">成色等级:<span
                                                    style="color: #ff687b;">靓机</span></span>
                                        </div>

                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

            </div>
            <div style="width: 100%;height: 20px;">
            </div>
        </el-dialog>
        <!--成色等级匹配情况弹框-->
        <el-dialog title="成色识别情况" :visible.sync="qualityvisible" :close-on-click-modal="false" width="1000px"
            @close="qualityclose">
            <p style="margin-bottom: 10px;">最终成色等级为：<span style="color:#00C003;"
                    v-if="csObj.healthCode == 'Nice'">靓机</span>
                <span style="color: #ff8080;" v-if="csObj.healthCode == 'Little_Snow'">小花</span>
                <span style="color: #FFCB00;" v-if="csObj.healthCode == 'Big_Snow'">大花</span>
                <span style="color: #ff8080;" v-if="csObj.healthCode == 'Out_Burst'">外爆</span>
                <span style="color: #ff8080;" v-if="csObj.healthCode == 'Inner_Burst'">内爆</span>
                <span style="color: #ff8080;" v-if="csObj.healthCode == 'Other'">其他</span>
                <span style="color: #00C003;" v-if="csObj.healthCode == 'Nice_Lower'">小花靓</span>
            </p>
            <p style="margin-bottom: 10px;" class="linetitle">若外观功能项未匹配到则默认：其他</p>
            <p style="margin-bottom: 25px;" class="linetitle">若外观功能项匹配到成色，则按最低成色规则</p>

            <el-table :data="csObj.records" border style="width: 100%" class="mytable">
                <el-table-column label="匹配来源" width="130px" prop="source" align="center">
                    <template slot-scope="{ row }">
                        <span v-if="row.matchSource == '00'">外观功能项</span>
                        <span v-if="row.matchSource == '01'">图片识别</span>
                        <span v-if="row.matchSource == '02'">故障匹配</span>
                    </template>
                </el-table-column>
                <el-table-column label="识别成色等级" width="130px" prop="level" align="center">
                    <template slot-scope="{ row }">
                        <span>{{ row.healthName }}</span>
                        <p style="color: #0981ff; cursor: pointer; text-decoration: underline"
                            @click="seeImgRecord(row)" v-if="row.matchSource == '01'">查看</p>
                    </template>
                </el-table-column>
                <el-table-column label="备注" width="130px" prop="remark" align="center">
                    <template slot-scope="{ row }">
                        <span>{{ row.note }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width: 100%;height: 20px;"></div>
        </el-dialog>
        <!-- 配置列 -->
        <el-dialog title="配置列数据" :visible.sync="configShow" width="20%">
            <GlobalTable ref="multipleTable" :columns="configList" :data="configData" :maxHeight="500"
                :isPagination="false" @handleSelect="handleSelectionChange">
                <el-table-column :reserve-selection="true" type="selection" slot="checkColumn" align="center">
                </el-table-column>
            </GlobalTable>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelConfig">取 消</el-button>
                <el-button type="primary" @click="handleConfig">确 定</el-button>
            </span>
        </el-dialog>
        <!--查看报价记录弹框-->
        <el-dialog :close-on-click-modal="false" :width="`80%`" title="查看参与报价回收商" :visible="storeShow"
            @close="storeClose" top="1%">
            <div class="img-box">
                <div class="noteLayout">
                    <p class="lv_fc_red" style="margin-bottom: 10px">
                        说明：门店所看到的报价金额是商户的初始报价
                    </p>
                    <div>
                        <el-button type="danger" size="mini" plain :loading="expButtonLoading" v-if="isShowExpButton"
                            @click="openNegotiatePriceDia">申请议价</el-button>
                        <el-button type="warning" size="mini" plain @click="handleConfigColumns">配置列数据</el-button>
                        <el-button v-if="quotePriceData.length != 0" type="text" @click="onQuotePrice">
                            已邀请{{ quotePriceData.length }}家外部商家报价>
                        </el-button>
                    </div>
                </div>
                <GlobalForm ref="storeFormItemList" :form-item-list="storeFormItemList" :inline="true" :labelWidth="80"
                    :initData="storeFormInitData" round @handleConfirm="storeHandleConfirm" confirmBtnName="查询">
                </GlobalForm>

                <div class="table_list">
                    <GlobalTable ref="GlobalTable" v-loading="storeLoading" v-if="configRefresh" :columns="storeColumns"
                        :data="storeList" :isPagination="false" @handleCurrentChange="handleCurrentChange"
                        :max-height="700">
                        <el-table-column slot="recycleMerchantName" label="报价商家" align="center" width="200">
                            <template v-slot="{ row }">
                                <el-tag v-if="row.recycleMerchantName == merchantName" size="mini" type="danger"
                                    effect="dark" style="margin-right: 10px">
                                    成交
                                </el-tag>

                                <span>{{ row.recycleMerchantName }}</span>
                                <el-tag v-if="
                                    row.isStandardRecycleMerchant &&
                                    row.isStandardRecycleMerchant !== '--'
                                " size="mini" type="warning" style="margin-left: 10px">虚拟基数</el-tag>
                                <div>
                                    <div style="
                      background: rgb(245, 245, 255);
                      border-radius: 4px;
                      padding: 0px 8px;
                      margin-top: 4px;
                      display: inline-block;
                    " v-if="
                        row.virtualName &&
                        baoPricestate == '00' &&
                        row.virtualName !== '--'
                    ">
                                        {{ row.virtualName }}
                                    </div>
                                </div>
                                <div>
                                    <el-tag v-if="
                                        row.isMapping" size="mini" type="danger" effect="dark"
                                        style="margin-right: 10px">
                                        映射商家
                                    </el-tag>
                                    <el-tag v-if="
                                        row.isFixHighQuote &&
                                        row.recycleMerchantName != merchantName &&
                                        row.isFixHighQuote != '--'
                                    " size="mini" type="warning" effect="dark" style="margin-right: 10px">
                                        首次取价
                                    </el-tag>
                                    <el-tag v-if="
                                        row.isFixExpPrice &&
                                        row.recycleMerchantName != merchantName &&
                                        row.isFixExpPrice != '--'
                                    " size="mini" type="warning" effect="dark">
                                        议价取价
                                    </el-tag>
                                    <el-tag v-if="row.isAddPrice && row.isAddPrice != '--'" size="mini" type="success"
                                        effect="dark">
                                        平台加价
                                    </el-tag>
                                </div>
                                <div class="isdeal1" v-if="row.isOutMerchant == true">外部</div>
                            </template>
                        </el-table-column>
                        <el-table-column slot="originalQuotePrice" label="报价金额（含差异基金）" align="center" min-width="100">
                            <template slot-scope="{ row }">
                                {{ row.originalQuotePrice }}
                                <div v-if="row.isMockQuoteOpen">
                                    虚拟报价：<span class="price">¥{{ row.mkOriginalQuotePrice }}</span>
                                </div>
                                <!--添加判断条件非老年机-->
                                <div v-if="row.isAutoQuote && row.isAutoQuote !== '--' && row.originalQuotePrice != '--' && row.originalQuotePrice > 0 && row.outType !== 'lb' && row.outType !== 'lb2' && row.orderLowView == '--' && !isElderlyMachine"
                                    style="color:#FFAF29;text-decoration: underline;cursor: pointer;"
                                    @click="seeAutoQuote">查看</div>
                                <!--以下查看显示规则为:低端机的自动报价 -->
                                <div v-if="row.orderLowView && row.orderLowView !== '--'"
                                    style="color:#FFAF29;text-decoration: underline;cursor: pointer;"
                                    @click="seeAutoQuoteDetail(row)">查看
                                </div>
                                <!--以下查看显示规则为:功能机老年机的自动报价 -->
                                <div v-if="isElderlyMachine && isElderlyMachine !== '--' && row.isAutoQuote && row.isAutoQuote !== '--'"
                                    style="color:#FFAF29;text-decoration: underline;cursor: pointer;"
                                    @click="seeLowDetail(row)">查看</div>

                                <div v-if="row.isExamineQuote === true"
                                    style="color:#0981FF;text-decoration: underline;cursor: pointer;"
                                    @click="openQuoteInfo(row)">审单报价详情
                                </div>
                                <div v-if="row.isQuoterQuick === true"
                                    style="color:#0981FF;text-decoration: underline;cursor: pointer;"
                                    @click="openQuoteInfo(row)">快捷报价详情</div>

                                <div v-if="row.isRiskQuote == true"
                                    style="color:#FFAF29;text-decoration: underline;cursor: pointer;"
                                    @click="autoQuoteDetail = row, autoQuoteDetailShow = true">查看
                                </div>
                                <!--回收商智能自动报价-->
                                <div style="color:#0981FF;text-decoration: underline;cursor: pointer;"
                                    v-if="row.isAutoQuote2 && row.isAutoQuote2 !== '--'" @click="seeNewauto(row)">查看
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column slot="quotePrice" label="报价金额" align="center">
                            <template scope="{ row }">
                                {{ row.quotePrice }}
                                <p v-if="row.isMockQuoteOpen">
                                    虚拟报价：<span class="price">¥{{ row.mkQuotePrice }}</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column width="150" slot="staffName" label="报价人" align="center">
                            <template scope="{ row }">
                                <template v-if="row.isMockQuoteOpen">
                                    {{ row.mkStaffName }}
                                    <span v-if="
                                        row.mkQuoteStaffPhone && row.mkQuoteStaffPhone != '--'
                                    ">- {{ row.mkQuoteStaffPhone }}</span>
                                    <span v-if="
                                        row.mkQuotePositionType && row.mkQuotePositionType != '--'
                                    ">-
                                        {{
                                            row.mkQuoteIsMajor === true
                                                ? "创建人"
                                                : row.mkQuotePositionType == "01"
                                                    ? "子账号"
                                                    : row.mkQuotePositionType == "02"
                                                        ? "报价师"
                                                        : "--"
                                        }}</span>
                                </template>
                                <template v-else>
                                    {{ row.staffName }}
                                    <span v-if="row.staffMobile && row.staffMobile != '--'">- {{ row.staffMobile
                                    }}</span>
                                    <span v-if="row.staffType && row.staffType != '--'">（{{ row.staffType }}）</span>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column slot="quoteNum" label="报价次数" align="center">
                            <template scope="{ row }">
                                <span v-if="row.quoteNum != '--' && row.quoteNum != 0" style="
                    text-decoration: underline;
                    cursor: pointer;
                    color: #0981ff;
                  " @click="Bargain(row, 'config')">{{ row.quoteNum }}</span>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column slot="state" label="订单状态" align="center">
                            <template scope="{ row }">
                                <span>{{
                                    row.state == "00-0"
                                        ? "待报价"
                                        : row.state == "00-1"
                                            ? "报价中"
                                            : row.state == "00-2"
                                                ? "已报价"
                                                : row.state == "01"
                                                    ? "已确认"
                                                    : row.state == "10" && row.exclusiveCancelTime != "--"
                                                        ? `取消抢单${row.exclusiveCancelTime}`
                                                        : "交易取消"
                                }}</span>
                                <p v-if="row.isMockQuoteOpen && row.mkQuoteState == '01'">
                                    <span class="price">虚拟报价</span>
                                </p>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column slot="state" label="是否映射报价" align="center">
              <template scope="{ row }">
               {{ row.state }}
               
              </template>
            </el-table-column> -->
                        <!-- <el-table-column slot="isNiceDevice" width="100" label="是否标记靓机" align="center">
              <template scope="{ row }">
                <span>{{ row.isNiceDevice == true ? "是" : "否" }}</span>
              </template>
            </el-table-column> -->
                        <el-table-column slot="quoteNote" label="报价备注" align="center">
                            <template scope="{ row }">
                                <el-tooltip v-if="row.quoteNote != '--'" class="item" effect="dark"
                                    :content="row.quoteNote == '--' ? '' : row.quoteNote" placement="bottom">
                                    <span class="quoteNotecss">{{ row.quoteNote }}</span>
                                </el-tooltip>

                                <span v-else>{{ row.quoteNote }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column slot="diffFundPrice" label="差异基金" align="center">
                            <template scope="{ row }">
                                {{ row.diffFundPrice }}
                                <p v-if="row.isMockQuoteOpen">
                                    虚拟：<span class="price">{{ row.mkDiffFundPrice }}</span>
                                </p>
                            </template>
                        </el-table-column> -->
                        <el-table-column slot="quoteChannelServerFee" width="100" label="渠道服务费" align="center">
                            <template scope="{ row }">
                                {{ row.quoteChannelServerFee }}
                                <div v-if="
                                    row.quoteChannelServerFee &&
                                    row.quoteChannelServerFee != '--'
                                " style="color: red">
                                    {{ row.matchServerFeeOnline == "01" ? "线上" : "线下" }}
                                </div>
                                <p v-if="row.isMockQuoteOpen">
                                    虚拟：<span class="price">{{ row.mkChannelServerFee }}</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column slot="freightWarehouseFee" width="100" label="到仓运费" align="center">
                            <template scope="{ row }">
                                {{ row.freightWarehouseFee }}
                                <div v-if="
                                    row.freightWarehouseFee &&
                                    row.freightWarehouseFee != '--'
                                " :style="row.freightWarehouseArrivalType == '00' ? 'color: red;' : 'color: #0981FF;'">
                                    {{ row.freightWarehouseArrivalType == "00" ? "内扣" : row.freightWarehouseArrivalType
                                        == "01" ? "外扣" : '' }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column slot="commission" width="100" label="外部预扣手续费" align="center">
                            <template scope="{ row }">
                                <span v-if="row.commission">{{ row.commission || "--" }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column slot="limitExclusiveLength" label="限时报价" align="center">
                            <template scope="{ row }">
                                <span>{{
                                    row.limitExclusiveLength == "--"
                                        ? "不限制"
                                        : row.limitExclusiveLength + "分钟"
                                }}</span>
                                <el-tag v-if="row.isBidding === true" size="mini" type="danger" effect="dark">
                                    已中标
                                </el-tag>
                            </template>
                        </el-table-column>
                    </GlobalTable>
                    <!-- </el-table> -->
                </div>
            </div>
        </el-dialog>
        <!--自动报价明细-->
        <el-dialog title="自动报价明细" :visible.sync="priceDetail" :close-on-click-modal="false" width="900px"
            @close="priceDetail = false">
            <div style="max-height: 70vh; overflow-y: auto;height: auto;">
                <div style="margin-bottom: 20px;display: flex;align-items: center;">
                    <p v-if="bjObj.healthCode == 'Nice'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'Nice'" class="liang" style="margin-right: 60px;">靓机</p>
                    <p v-if="bjObj.healthCode == 'Little_Snow'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'Little_Snow'" class="xiaohua" style="margin-right: 60px;">小花</p>
                    <p v-if="bjObj.healthCode == 'Big_Snow'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'Big_Snow'" class="dahua" style="margin-right: 60px;">大花</p>
                    <p v-if="bjObj.healthCode == 'Inner_Burst'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'Inner_Burst'" class="inner" style="margin-right: 60px;">内爆</p>
                    <p v-if="bjObj.healthCode == 'Out_Burst'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'Out_Burst'" class="waibao" style="margin-right: 60px;">外爆</p>
                    <p v-if="bjObj.healthCode == 'UnStart'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'UnStart'" class="wufa" style="margin-right: 60px;">无法开机</p>
                    <p v-if="bjObj.healthCode == 'Risk'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'Risk'" class="risk" style="margin-right: 60px;">风险机</p>
                    <p v-if="bjObj.healthCode == 'Nice_Lower'" style="font-weight: bold;">外观成色等级</p>
                    <p v-if="bjObj.healthCode == 'Nice_Lower'" class="risk" style="margin-right: 60px;">小花靓</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'CanStart'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'CanStart'" class="liang">正常开机</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'UnStart'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'UnStart'" class="wufa">无法开机</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'brand-new'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'brand-new'" class="liang">全新机</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Elderly'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Elderly'" class="liang">老年机</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Nice'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Nice'" class="liang">靓机</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Little_Snow'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Little_Snow'" class="liang">小花</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Big_Snow'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Big_Snow'" class="dahua">大花</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Inner_Burst'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Inner_Burst'" class="inner">内爆</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Out_Burst'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Out_Burst'" class="waibao">外爆</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Risk'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Risk'" class="risk">风险机</p>
                    <p style="font-weight: bold;" v-if="bjObj.quoteHealthCode == 'Nice_Lower'">命中自动报价成色等级</p>
                    <p style="margin-left: 10px;" v-if="bjObj.quoteHealthCode == 'Nice_Lower'" class="risk">小花靓</p>
                </div>
                <p
                    style="margin-bottom: 20px;font-weight: bold;background: #F7F8FB;border-radius: 6px;height: 32px;line-height: 32px;padding-left: 10px;">
                    <span style="margin-right: 100px;">等级报价:<span style="margin-left: 10px;color:#0981FF">{{
                        bjObj.autoOriQuotePrice }}元</span></span><span style="margin-right: 100px;">故障项扣减:<span
                            style="margin-left: 10px;color:#FF566B">{{ bjObj.faultSubPrice
                            }}元</span></span><span>自动报价:<span style="margin-left: 10px;color:#FF566B">{{
                                bjObj.autoQuotePrice }}元</span></span>
                </p>
                <div style="width:100%;height: 1px;background: #F5F6FA;margin: 15px 0;"></div>
                <p style="margin-bottom: 20px;font-weight: bold;display: flex;align-items: center;"><img
                        src="../../../assets/images/gantan.png" alt=""
                        style="width:14px;height: 14px;margin-right: 6px;" />故障项扣减明细
                </p>
                <div v-for="(item, index) in bjObj.failureSubs" :key="index">
                    <div style="display: flex;">
                        <p class="title-base" v-if="item.failureType == '01'">外观</p>
                        <p class="title-base" v-if="item.failureType == '02'">主功能</p>
                        <p class="title-base" v-if="item.failureType == '03'">小功能</p>
                        <p class="title-base" v-if="item.failureType == '04'">其他</p>
                        <p style="color: #ff687b;margin-top: 1px;">总扣减{{ item.faultSubPrice }}元</p>
                    </div>
                    <el-table :data="item.items" border style="width: 100%;margin-bottom: 20px;" id="excelOrder"
                        class="mytable1">
                        <el-table-column type="index" width="50" label='序号' align="center">
                        </el-table-column>
                        <el-table-column label="扣减方式" prop="date" align="center" width="150px">
                            <template slot-scope="{ row }">
                                <span v-if="row.subType == '00'">整体扣减</span>
                                <span v-if="row.subType == '01'">指定项扣减</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="故障项" prop="date" align="center" width="150px">
                            <template slot-scope="{ row }">
                                <span>{{ row.failureName || "/" }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="扣减费用" prop="date" align="center" width="150px">
                            <template slot-scope="{ row }">
                                <span>{{ row.subPrice }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" prop="date" align="center">
                            <template slot-scope="{ row }">
                                <span>{{ row.subNote }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="bjObj.failureSubs && bjObj.failureSubs.length == 0"
                    style="display: flex;justify-content: center;margin-bottom: 90px;">
                    <img src="@/assets/images/bjk.png" alt style="display: block;width: 180px;height: 97px;">
                </div>
                <div style="width: 100%;height: 20px;" v-if="bjObj.failureSubs && bjObj.failureSubs.length !== 0"></div>
            </div>
        </el-dialog>
        <DialogDownLoad v-if="isShowDownloadSuccess" :isShowDownloadSuccess="isShowDownloadSuccess"
            @close="closebillDown" @config="billconfig"></DialogDownLoad>
        <!-- 导出Excel谷歌验证 -->
        <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px"
            @closed="closeExport">
            <div class="cance-tip">
                <div class="tip-sure">是否确认导出订单？</div>
            </div>
            <div class="command">
                <div style="width: 88px">动态口令：</div>
                <el-input v-model="code" placeholder="请输入谷歌动态口令"
                    oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click.native="closeExport">取消</el-button>
                <el-button type="primary" :loading="codeLoading" @click.native="codeSubmit">确定</el-button>
            </span>
        </el-dialog>
        <!-- 旧机功能情况 -->
        <el-dialog v-bind="imeiTestProps" :before-close="() => (imeiTestProps.show = false)"
            :visible.sync="imeiTestProps.show">
            <div v-loading="imeiTestProps.isLoadding" class="function_box">
                <!-- 旧机基本情况所有情况都有--新旧/外部 -->
                <div class="test-info">
                    <Title title="旧机基本情况" />
                    <!-- 没有机型名称且不是老年机或者功能机，取phoneName字段(新询价方案也需要展现旧机相关信息和规格) -->
                    <TestDeviceInfo :externalorderType="externalorderType" :datainfo="detailData" />
                </div>
                <div>
                    <!-- 估价单验机报告 -->
                    <div class="test-box">
                        <div class="test-result" v-if="detailData.functionView.errorList.length">
                            <Title :title="'异常项（共' +
                                detailData.functionView.errorList.length +
                                '项）'
                                " />
                            <!-- 旧机无系统检测 -->
                            <div class="mb10" v-if="
                                detailData.unableDetectionCause &&
                                detailData.detectionType == '01'
                            ">
                                <span class="fs16">旧机无法系统检测原因：</span>
                                <span class="lv_fc_red fs16">{{
                                    detailData.unableDetectionCause || "--"
                                    }}</span>
                            </div>
                            <div class="mb10" style="display: flex; justify-content: space-between"
                                v-if="detailData.detectionType == '02'">
                                <span class="fs16">检测机型：{{ detailData.detectionModel || "--" }}</span>
                                <span class="fs16">录入串号：{{ detailData.imei || "--" }}</span>
                            </div>
                            <TestTable :externalorderType="externalorderType"
                                :table-data="detailData.functionView.errorList">
                            </TestTable>
                        </div>
                        <div class="test-result" style="margin-top: 20px"
                            v-if="detailData.functionView.normalList.length">
                            <Title :title="'正常项（共' +
                                detailData.functionView.normalList.length +
                                '项）'
                                " />
                            <TestTable :externalorderType="externalorderType"
                                :table-data="detailData.functionView.normalList">
                            </TestTable>
                        </div>
                    </div>
                </div>
                <!-- 新增店员备注--所有情况下都有 -->
                <div style="margin: 15px 0 25px 0">
                    <Title title="店员备注" />
                    <Remark :remark="detailData.remark" :againPhotoRemark="detailData.againPhotoRemark"
                        :aprAgreementRemark="detailData.aprAgreementRemark" />
                </div>
            </div>
            <div slot="footer">
                <el-button v-if="imeiTestProps.type === '01'" @click="imeiTestProps.show = false" plain
                    type="primary">关闭
                </el-button>
                <div v-else>
                    <el-button @click="imeiTestProps.show = false">取 消</el-button>
                    <el-button type="primary" @click="imeiTestProps.show = false">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        <AmountDetailDia v-if="amountDetailDiaShow" :dialogVisible="amountDetailDiaShow" :merchantId="rowItemMerchantId"
            :type="amountDetailDiaType" :orderNo="orderNo" @close="amountDetailDiaShow = false"
            :isExamineQuote1="isExamineQuote1" :isQuoterQuick1="isQuoterQuick1" />
        <!--新增查看功能机老年机报价明细-->
        <el-dialog title="自动报价明细" :visible.sync="lowInfoVisibleDetail" :close-on-click-modal="false" width="400px">
            <div class="auto-info-dia">
                <p style="font-weight: bold;">功能机老年机自动报价</p>
                <p>自动报价金额：<span style="color: #0981ff;">{{ lowinfo }}元</span></p>
                <!--新增单价-->
                <p>单台报价:{{ lowprice }}元(共{{ lownum }}台)</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="lowInfoVisibleDetail = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog title="自动报价明细" @close="autoQuoteDetailShow = false, autoQuoteDetail = {}"
            :visible.sync="autoQuoteDetailShow" :close-on-click-modal="false" width="400px">
            <div class="auto-info-dia" style="margin-bottom: 20px;">
                <div style="color: #FF687B;">该订单已触发黑名单门店/店员，默认报极低价</div>
            </div>
            <div>
                自动报价：{{ autoQuoteDetail.riskQuotePrice }}元
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="autoQuoteDetailShow = false, autoQuoteDetail = {}">关闭</el-button>
            </span>
        </el-dialog>
        <!--新增查看报价明细-->
        <el-dialog title="自动报价明细" :visible.sync="autoInfoVisibleDetail" :close-on-click-modal="false" width="400px">
            <div class="auto-info-dia" v-loading="autoInfoDiaDetailLoading">
                <p style="font-weight: bold;">低端机自动报价</p>
                <p>故障项：<span style="color: #0981ff;">{{ orderLowView.optionName }}</span></p>
                <p>自动报价金额：<span style="color: #0981ff;">{{ orderLowView.price }}元</span></p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="autoInfoVisibleDetail = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog title="自动报价明细" :visible.sync="autoInfoVisible" :close-on-click-modal="false" width="400px">
            <div class="auto-info-dia" v-loading="autoInfoDiaLoading">
                <div class="flex auto-info-dia-tip">
                    <p :class="orderAutoInfo.source === '00' ? 'general-blue' : 'general-yellow'">{{
                        orderAutoInfo.source ===
                            '00' ? '通用机型自动报价' : '指定机型自动报价' }}</p>
                    <div class="status_grd" :class="orderAutoInfo.isHighRisk ? 'abnormal' : ''">
                        {{ orderAutoInfo.isHighRisk ? '已触发高风险' : '未触发高风险' }}</div>
                </div>
                <p v-if="orderAutoInfo.source === '01'">报价方式：{{ orderAutoInfo.quoteWay == '00' ? '自定义系数' : '自定义报价' }}
                </p>
                <p v-if="orderAutoInfo.quoteWay == '00'">
                    <span v-if="orderAutoInfo.calcStandard === '00'">分毫靓机价：{{ orderAutoInfo.initNicePrice }}元</span>
                    <span v-else>{{ orderAutoInfo.source === '00' ? '预估价' : autoInfoOutType ===
                        'honor' ? '分毫靓机价' : '预估价' }}：{{ orderAutoInfo.estimatedPrice }}元</span>
                </p>
                <p v-if="orderAutoInfo.quoteWay == '00'">计算系数：{{ orderAutoInfo.usePriceOrRate }}（{{
                    orderAutoInfo.autoQuoteExplain
                }}）
                </p>
                <p>自动报价金额：{{ orderAutoInfo.autoQuotePrice }}元<span
                        v-if="orderAutoInfo.source === '01' && orderAutoInfo.quoteWay == '01'">（{{
                            orderAutoInfo.autoQuoteExplain
                        }}）</span>
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="autoInfoVisible = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :width="`${1300}px`" title="查看报价记录" :visible="viewrecords"
            @close="viewrecordsClose" top="15%" bottom="10%">
            <div class="table_list autoshow" style="padding-bottom: 20px">
                <el-table :data="getUpdatedQuoteLog" max-height="300" border style="width: 100%" id="updatedOrder">
                    <el-table-column prop="rank" width="70" label="报价次序" align="center"></el-table-column>
                    <el-table-column prop="quoteTime" width="160" label="报价时间" align="center">
                        <template slot-scope="{ row }">
                            <span>{{ row.quoteTime }}</span>
                            <el-tag v-if="
                                row.isMappingQuote" size="mini" type="danger" effect="dark" style="margin-right: 10px">
                                映射报价
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价人" align="center">
                        <template slot-scope="{ row }">
                            <span>{{ row.exclusiveQuoterName }}-{{
                                row.isMajor
                                    ? "创建人"
                                    : row.positionType == "01"
                                        ? "子账号"
                                        : "报价师"
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100" label="报价金额" align="center">
                        <template slot-scope="{ row }">
                            <span>￥{{ row.quotePrice }}</span>
                            <div>
                                <el-tag type="danger" size="small" effect="plain" v-if="row.isInside">内部加价</el-tag>
                            </div>
                            <p v-if="row.isMockQuoteOpen">
                                虚拟报价：<span class="price">¥{{ row.mkQuotePrice }}</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价备注" align="center">
                        <template slot-scope="{ row }">
                            <el-tooltip v-if="row.quoteNote" class="item" effect="dark" :content="row.quoteNote"
                                placement="top">
                                <div class="quoteNotecss">
                                    {{ row.quoteNote }}
                                </div>
                            </el-tooltip>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否为映射报价" align="center">
                        <template slot-scope="{ row }">
                            <span v-if="row.isMappingQuote" style="color: red;">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <!-- 新增 -->
                    <el-table-column prop="originalQuotePrice" width="100" label="报价金额（含差异基金）" align="center">
                        <template slot-scope="{ row }">
                            <span>￥{{ row.originalQuotePrice }}</span>
                            <p v-if="row.isMockQuoteOpen">
                                虚拟报价：<span class="price">¥{{ row.mkOriginalQuotePrice }}</span>
                            </p>
                            <!--回收商智能自动报价-->
                            <div style="color:#0981FF;text-decoration: underline;cursor: pointer;"
                                v-if="row.isAutoQuote2 && row.isAutoQuote2 !== '--'" @click="seeNewauto(row, row.id)">查看
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="diffFundPrice" width="100" label="差异基金" align="center">
                        <template slot-scope="{ row }">
                            <span>￥{{ row.diffFundPrice }}</span>
                            <p v-if="row.isMockQuoteOpen">
                                虚拟：<span class="price">{{ row.mkDiffFundPrice }}</span>
                            </p>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="quoteChannelServerFee" width="100" label="渠道服务费" align="center">
                        <template slot-scope="{ row }">
                            <span>￥{{ row.quoteChannelServerFee }}</span>
                            <p v-if="row.isMockQuoteOpen">
                                虚拟：<span class="price">{{ row.mkChannelServerFee }}</span>
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="color: #0981ff; font-size: 16px; margin: 20px 0"
                    v-if="remakeQuoteLog && remakeQuoteLog.length">
                    补拍后报价记录
                </div>
                <el-table v-if="remakeQuoteLog && remakeQuoteLog.length" :data="remakeQuoteLog" max-height="300" border
                    style="width: 100%" id="remakeOrder">
                    <el-table-column prop="rank" width="70" label="报价次序" align="center"></el-table-column>
                    <el-table-column prop="remakeTime" width="100" label="补拍时间" align="center"></el-table-column>
                    <el-table-column prop="quoteTime" width="100" label="报价时间" align="center"></el-table-column>
                    <el-table-column label="报价人" align="center">
                        <template slot-scope="{ row }">
                            <span>{{ row.exclusiveQuoterName }}-{{
                                row.isMajor
                                    ? "创建人"
                                    : row.positionType == "01"
                                        ? "子账号"
                                        : "报价师"
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100" label="报价金额" align="center">
                        <template slot-scope="{ row }">
                            <span>￥{{ row.quotePrice }}</span>
                            <div>
                                <el-tag type="danger" size="small" effect="plain" v-if="row.isInside">内部加价</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="报价备注" align="center">
                        <template slot-scope="{ row }">
                            <el-tooltip v-if="row.quoteNote" class="item" effect="dark" :content="row.quoteNote"
                                placement="top">
                                <div class="quoteNotecss">
                                    {{ row.quoteNote }}
                                </div>
                            </el-tooltip>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <!-- 新增 -->
                    <el-table-column prop="originalQuotePrice" width="100" label="报价金额（含差异基金）"
                        align="center"></el-table-column>
                    <!-- <el-table-column prop="diffFundPrice" width="100" label="差异基金" align="center"></el-table-column> -->
                    <el-table-column prop="quoteChannelServerFee" width="100" label="渠道服务费"
                        align="center"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <!--开机亮屏照-->
        <el-dialog title="开机亮屏照识别详情" :visible.sync="kjimgvisible" :close-on-click-modal="false" width="724px"
            @close="kjimgclose">
            <div style="margin-bottom: 20px;">
                <div style="    background-color: #fff0f2;padding: 5px;" v-if="kjaisbObj.autoCheckBrightScreenFee&&kjaisbObj.autoCheckBrightScreenFee !== '--'"><span>平台查询费用:</span><span style="margin-left: 5px;
    color: red;">{{ kjaisbObj.autoCheckBrightScreenFee }}元/</span><span>单,</span><span>按自动报价单-已校验开机亮屏照商家收取</span></div>
                <div style="    background-color: #fff0f2;padding: 5px;"
                    v-if="!kjaisbObj.autoCheckBrightScreenFee || kjaisbObj.autoCheckBrightScreenFee == '--'">本单不满足扣费条件</div>
            </div>
            <div style="margin-bottom: 20px;">
                <el-radio-group v-model="kjrgType" @change="screenphotochange">
                    <el-radio-button :label="'yes'" style="margin-right: 10px;border-radius: 6px;">亮屏照({{
                        kjaisbObj.lightScreenNum
                        }})</el-radio-button>
                    <el-radio-button :label="'no'" style="margin-right: 10px;border-radius: 6px;">非亮屏照({{
                        kjaisbObj.notLightScreenNum
                        }})</el-radio-button>
                    <el-radio-button :label="'fault'" style="margin-right: 10px;border-radius: 6px;">识别失败({{
                        kjaisbObj.errorNum
                        }})</el-radio-button>
                </el-radio-group>
            </div>
            <div class="img_box" style="display: flex;">
                <div class="read_image" ref="readImage">
                    <div class="primary-img" v-for="(item, index) in currentscreenImg" :key="index">
                        <canvas :ref="'myscreenCanvas' + index" :id="'myscreenCanvas-' + index"
                            @click="seeDetail(item)"></canvas>
                        <div class="labelbox">
                            <p style="margin-bottom: 10px;font-weight: bold;" v-if="kjrgType !== 'fault'">识别机型:</p>
                            <p style="margin-bottom: 10px;font-weight: bold;" v-if="kjrgType == 'fault'">失败原因:</p>
                            <div v-if="!item.lightPhoneName" style="width: 60px;
height: 20px;
background: rgba(180,188,204,0.22);
border-radius: 4px;font-size: 12px;text-align: center;">
                                无
                            </div>
                            <div v-if="item.lightPhoneName && kjrgType !== 'fault'" style="width: 120px;
height: 40px;
background: #FFF5E6;
border-radius: 4px;font-size: 12px;text-align: center;line-height: 40px;color: rgb(255, 161, 27);">
                                {{ item.lightPhoneName }}
                            </div>
                            <template v-if="kjrgType == 'error'">
                                <div v-for="(item, index) in item.tags" :key="index" class="myboxtel">
                                    <div>
                                        <div type="warning" style="margin-bottom: 10px;color: #F59A23;">{{
                                            item.tagName }}</div>
                                    </div>
                                    <div>
                                        <div style="margin-bottom: 10px;">
                                            <span v-if="item.healthCode == 'Little_Snow'">成色等级:<span
                                                    style="color: #ff687b;">小花</span></span>
                                            <span v-if="item.healthCode == 'Big_Snow'">成色等级:<span
                                                    style="color: #ff687b;">大花</span></span>
                                            <span v-if="item.healthCode == 'Out_Burst'">成色等级:<span
                                                    style="color: #ff687b;">外爆</span></span>
                                            <span v-if="item.healthCode == 'Inner_Burst'">成色等级:<span
                                                    style="color: #ff687b;">内爆</span></span>
                                            <span v-if="item.healthCode == 'Other'">成色等级:<span
                                                    style="color: #ff687b;">其他</span></span>
                                            <span v-if="item.healthCode == 'Nice'">成色等级:<span
                                                    style="color: #ff687b;">靓机</span></span>
                                        </div>

                                    </div>
                                </div>
                            </template>
                            <template v-if="kjrgType == 'fault'">
                                <div class="myboxtel" v-if="item.errorCause">
                                    <div>
                                        <div style="color:red">{{ item.errorCause }}</div>
                                    </div>

                                </div>
                            </template>

                        </div>
                    </div>
                </div>

            </div>
            <div style="width: 100%;height: 20px;">
            </div>
        </el-dialog>
    </div>
</template>
<script>
// import GardenSlwct from "@/components/common/gardenSlwct.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import _api from "@/utils/request";
import moment from "moment";
import { tableDatas, dialogProps, imeiTestProps } from "@/views/RecallOrder/initState";
import TestDeviceInfo from "@/views/RecallOrder/componets/TestDeviceInfo.vue";
import TestTable from "@/views/RecallOrder/componets/TestTable.vue";
import Title from "../componets/Title.vue"
import DialogDownLoad from "@/components/global/components/DialogDownLoad.vue"
import Remark from "@/views/RecallOrder/componets/Remark.vue";
import AmountDetailDia from "@/views/RecallOrder/componets/AmountDetailDia.vue";
import {
    getOutNameMake,
    getHealthCode
} from "@/utils/common";
export default {
    name: "OrderTable",
    components: {
        // GardenSlwct,
        ElImageViewer,
        Title,
        TestDeviceInfo,
        TestTable,
        DialogDownLoad,
        Remark,
        AmountDetailDia,
    },
    data() {
        return {
            loading: false,
            tabData: [
                {
                    text: "普通只能报价",
                    value: "00",
                    num: 0,
                    key: "unMarkNum",
                    hideNum: true
                },
                {
                    text: "AI智能自动报价",
                    value: "01",
                    num: 0,
                    key: "markNum",
                    hideNum: true
                },
            ],
            activeIndex: 0,
            Excelloading: false,
            pages: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },
            orderTableList: [],
            imgShow: false,
            DialogImgList: [[], []],
            imgList: [],
            showViewer: false,
            imgShowOnly: true,
            imgIndex: 0,
            dialogProps,
            rowObj: {},
            skuvisible: false,
            imgvisible: false,
            rgType: 'error',
            currentImg: [],
            qualityvisible: false,
            qualityList: [],
            imgShowIndex: 0,
            reoptDataList: [{ source: "2025-09-02 14:11:44", level: "复合肥", price: "188", remark: "划分方法" }],
            priceDetail: false,
            bjObj: {},
            aisbObj: {},
            csObj: {},
            codeShow: false,
            code: "",
            codeLoading: false,
            isShowDownloadSuccess: false,
            externalorderType: "", //订单类型
            imeiTestProps,
            // 功能情况接口
            detailData: {
                functionView: {
                    normalList: [],
                    errorList: [],
                },
                basicFunctionList: [],
                plugFunctionList: [],
                informationList: [],
            },
            storeShow: false,
            isShowExpButton: false, //是否显示议价按钮，dev-2.5.1屏蔽
            quotePriceData: [],
            storeFormItemList: [
                {
                    key: "recycleMerchantName",
                    type: "input",
                    labelName: "报价商家",
                    placeholder: "请输入报价商家",

                },
                {
                    key: "isMappingQuote",
                    type: "select",
                    labelName: "是否为映射商家",
                    placeholder: "请选择是否为映射商家",
                    lableWidth: '130px',
                    option: [
                        {
                            value: null,
                            label: "全部",
                        },
                        {
                            value: true,
                            label: "是",
                        },
                        {
                            value: false,
                            label: "否",
                        },
                    ],
                },
                {
                    key: "isAutoQuote",
                    type: "select",
                    labelName: "是否自动报价",
                    placeholder: "请选择",
                    lableWidth: '130px',
                    option: [
                        {
                            value: null,
                            label: "全部",
                        },
                        {
                            value: true,
                            label: "是",
                        },
                        {
                            value: false,
                            label: "否",
                        },
                    ],
                },
            ],
            storeFormInitData: {
                isMappingQuote: null,
                recycleMerchantName: ''
            },
            configRefresh: true,
            storeLoading: false,
            storeColumns: [
                { slotName: "recycleMerchantName" }, //报价商家
                // { label: "报价金额（含差异基金）", prop: "originalQuotePrice" }, //报价金额
                { slotName: "originalQuotePrice" }, //报价金额
                // { label: "报价金额", prop: "quotePrice" }, //报价金额
                { slotName: "quotePrice" }, //报价金额
                { label: "用户成交价", prop: "quoteSecretPrice" }, //用户成交价
                { label: "抢单时间", prop: "exclusiveTime" }, //抢单时间
                { label: "最新报价时间", prop: "quoteTime" }, //最新报价时间
                { slotName: "staffName" }, //报价人
                { slotName: "quoteNum" }, //报价次数
                { slotName: "state" }, //报价状态
                // { slotName: "yinshebaojia" }, //是否映射报价
                // { slotName: "isNiceDevice" }, //是否标记靓机
                { slotName: "quoteNote" }, //报价备注
                // { label: "差异基金", prop: "diffFundPrice" }, //差异基金
                // { slotName: "diffFundPrice" }, //差异基金
                { slotName: "quoteChannelServerFee" }, //渠道服务费
                { slotName: "freightWarehouseFee" }, //到仓运费
                { slotName: "commission" }, //外部预扣手续费
                { slotName: "limitExclusiveLength" }, //限时报价
            ],
            storeList: [],
            middleColumns: [],
            configData: [
                {
                    prop: "recycleMerchantName",
                    label: "报价商家",
                },
                {
                    prop: "originalQuotePrice",
                    label: "报价金额（含差异基金）",
                },
                {
                    prop: "quoteSecretPrice",
                    label: "用户成交价",
                },
                {
                    prop: "exclusiveTime",
                    label: "抢单时间",
                },
                {
                    prop: "quoteTime",
                    label: "最新报价时间",
                },
                {
                    prop: "staffName",
                    label: "报价人",
                },
                {
                    prop: "quoteNum",
                    label: "报价次数",
                },
                {
                    prop: "state",
                    label: "报价状态",
                },
                {
                    prop: "isNiceDevice",
                    label: "是否标记靓机",
                },
                {
                    prop: "quoteNote",
                    label: "报价备注",
                },
                {
                    prop: "quotePrice",
                    label: "报价金额",
                },
                // {
                //     prop: "diffFundPrice",
                //     label: "差异基金",
                // },
                {
                    prop: "quoteChannelServerFee",
                    label: "渠道服务费",
                },
                {
                    prop: "freightWarehouseFee",
                    label: "到仓运费",
                },
                {
                    prop: "commission",
                    label: "外部预扣手续费",
                },
                {
                    prop: "limitExclusiveLength",
                    label: "限时报价时长",
                },
            ],
            configShow: false,
            configList: [
                { label: "列名", prop: "label" },
                { slotName: "checkColumn" }, //显示
            ],
            amountDetailDiaShow: false,
            rowItemMerchantId: "",
            amountDetailDiaType: "",
            orderNo: "",
            lowInfoVisibleDetail: false,
            autoInfoDiaDetailLoading: false,
            lowinfo: "",
            lowprice: "",
            lownum: "",
            autoQuoteDetail: {},
            orderLowView: {},//低端自动报价
            autoInfoVisibleDetail: false,
            autoInfoDiaLoading: false,
            orderAutoInfo: {},
            autoInfoVisible: false,
            autoQuoteDetailShow: false,
            viewrecords: false,
            getUpdatedQuoteLog: [],
            remakeQuoteLog: [],
            skuInfo: {},
            kjrgType: 'yes',
            kjimgvisible: false,
            currentscreenImg: [],
            resultscreenData: [],
            kjaisbObj: {}
        };
    },
    created() {
        this.merchantId = this.$route.query.id;
        let startTime = moment()
            .day(moment().day())
            .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推一周的时间
        let endTime = moment().format("YYYY-MM-DD 23:59:59");
        this.ClearSeachParams();
        const baseRequest = {
            endTime: moment(endTime).format("x"),
            startTime: moment(startTime).format("x"),
        };
        this.$store.commit("tagsView/SEACH_PARAMS", baseRequest);
        this.middleColumns = [...this.storeColumns];

    },
    computed: {
        SeachParams() {
            return this.$store.state.tagsView.SeachParams;
        },
    },
    watch: {
        SeachParams(newval) {
            console.log(newval, "SeachParamsSeachParams");
            this.handleCurrentChange();
        },
    },
    methods: {
        // tab状态操作
        tabAction(v) {
            console.log(v);
            this.activeIndex = v;
            this.params.markState = this.tabData[v].value;
            console.log(this.params.markState, "lllllllllljh");
            this.handleCurrentChange(1);
        },
        ClearSeachParams() {
            this.$store.dispatch("tagsView/ClearSeachParams", "");
        },
        //表格第哦啊用
        handleCurrentChange(val) {
            //  暂时
            this.loading = true;
            if (val) {
                this.pages.currentPage = val;
            } else {
                this.pages.currentPage = 1;
            }
            const vo = {
                orderNo: this.SeachParams.orderNo,
                imei: this.SeachParams.imei,
                companyIds: this.SeachParams.companyIds,
                typeId: this.SeachParams.typeId,
                modelCode: this.SeachParams.modelCode,
                brandNo: this.SeachParams.brandNo,
                state: this.SeachParams.state,
                openMachineCondition: this.SeachParams.openMachineCondition,
                healthCode: this.SeachParams.healthCode,
                finenessHealthCode: this.SeachParams.finenessHealthCode,
                finenessHealthCodes: this.SeachParams.finenessHealthCodes,
                failureIds: this.SeachParams.failureIds,
                // sku: this.sku,
                isAiIdentify: this.SeachParams.isAiIdentify,
                tagIdList: this.SeachParams.tagIdList,
                endTime: this.SeachParams.endTime,
                startTime: this.SeachParams.startTime,
                pageNum: this.pages.currentPage,
                pageSize: this.pages.pageSize,
                merchantId: this.merchantId,
                lightScreenValidType: this.SeachParams.lightScreenValidType,
                lightScreenCompares: this.SeachParams.lightScreenCompares,
                skuValidType: this.SeachParams.skuValidType,
                modelCompares: this.SeachParams.modelCompares

            };
            _api.list(vo).then((res) => {
                console.log(res, 111111)
                if (res.code === 1) {
                    this.pages.total = res.data ? res.data.total : 0;
                    this.itemTable = res.data.records;
                    this.orderTableList = [];
                    for (let i = 0; i < this.itemTable.length; i++) {
                        this.itemArr = this.itemTable[i];
                        const outMake = getOutNameMake(this.itemTable[i].outType).make;
                        this.orderTableList.push(
                            this.handleData({
                                ...this.itemArr,
                                outMake,
                                healthCode: getHealthCode(this.itemArr.healthCode),
                            })
                        ); // 数据重新组装重置为--
                        if (i > 10) {
                            return;
                        }
                    }
                    this.loading = false;
                }
            }).finally(() => {
                if (typeof this.SeachParams.disuseLoding == "function") {
                    this.SeachParams.disuseLoding();
                }
            });
        },
        exportExcel() {
            this.codeShow = true;
        },
        closeExport() {
            this.codeShow = false;
            (this.code = ""), (this.codeLoading = false);
        },
        closebillDown() {
            this.isShowDownloadSuccess = false
        },
        billconfig() {
            this.isShowDownloadSuccess = false
            let routeData = this.$router.resolve({
                path: "/systemManage/downloadCenter",
            });
            window.open(routeData.href, "_blank");
        },
        codeSubmit() {

            if (!this.code) {
                return this.$message.error("请输入谷歌动态码");
            }

            const params = {
                ...this.SeachParams,
                pageNum: this.pages.currentPage,
                pageSize: this.pages.pageSize,
                merchantId: this.merchantId,
                command: this.code,
            };
            if (!params.startTime) {
                return this.$message.error("请选择导出时间查询");
            }
            this.codeLoading = true;
            console.log(params);
            _api
                .excel(params)
                .then((res) => {
                    console.log(res);
                    const content = res;
                    this.codeShow = false;
                    this.code = "";
                    const blob = new Blob([content]);
                    let reader = new FileReader(); // 创建读取文件对象
                    reader.addEventListener("loadend", () => {
                        try {
                            let data = JSON.parse(reader.result);
                            console.log(data)
                            if (data.code === 0) {
                                this.$message.error(data.msg || "导出失败");
                                this.isShowDownloadSuccess = false
                            }
                            if (data.code == 1) {
                                this.isShowDownloadSuccess = true
                            }
                        } catch (err) {
                            const fileName = "自动报价订单列表.xlsx";
                            if ("download" in document.createElement("a")) {
                                // 非IE下载
                                const elink = document.createElement("a");
                                elink.download = fileName;
                                elink.style.display = "none";
                                elink.href = URL.createObjectURL(blob);
                                document.body.appendChild(elink);
                                elink.click();
                                URL.revokeObjectURL(elink.href); // 释放URL 对象
                                document.body.removeChild(elink);
                            } else {
                                // IE10+下载
                                navigator.msSaveBlob(blob, fileName);
                            }
                        }
                    });
                    reader.readAsText(blob, "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
                    this.codeLoading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.codeLoading = false;
                });
        },
        openImgBox(row) {
            console.log(row);
            this.imgShow = true;
            this.DialogImgList = [
                [...(row.images == "--" || !row.images ? [] : row.images)],
                [...(row.reImages == "--" || !row.reImages ? [] : row.reImages)],
            ];
            console.log(this.DialogImgList);
        },
        imgClose() {
            console.log(1);
            this.imgShow = false;
            this.imgList = [];
            this.imgIndex = 0;
            this.imgShowIndex = 0
        },
        getindex(e) {
            console.log(e);
            this.imgShowIndex = e;
        },
        chooseImages(e) {
            if (e == 0) {
                this.imgIndex = 0;
                this.imgShowOnly = true;
            }
            if (e == 1) {
                this.imgIndex = 1;
                this.imgShowOnly = false;
            }
        },
        handleClick(row) {
            let routeData = this.$router.resolve({
                path: "/RecallOrder/Details",
                query: { type: "edit", id: row.orderNo },
            });
            window.open(routeData.href, "_blank");
        },
        //sku比对详情点击
        seeSkuDetail(row) {
            this.rowObj = row
            this.skuvisible = true
            let merchantId = this.$route.query.id
            _api.skuinfo({ orderNo: row.orderNo, merchantId }).then(res => {
                this.skuInfo = res.data
            })
        },
        //sku关闭
        skuclose() {
            this.rowObj = {}
            this.skuInfo = {}
            this.skuvisible = false
        },
        seeimgResult(row) {
            this.aisbObj = {}
            this.rowObj = row
            this.imgvisible = true
            _api.queryAIIdentify({ orderNo: row.orderNo }).then(res => {
                console.log(res, "成功后v比较好v计划")
                this.currentImg = res.data.exImages || [];
                this.loadImage();
                this.resultData = res.data.exImages
                this.aisbObj = res.data
            })
        },
        imgclose() {
            this.rowObj = {}
            this.imgvisible = false
            this.rgType = 'error'
        },
        buttonClick(type) {
            this.rgType = type
        },
        seeMatch(row) {
            this.rowObj = row
            this.qualityvisible = true
            this.csObj = {}
            _api.zdqueryFinenessHealthCode({ orderNo: row.orderNo }).then(res => {
                console.log(res, 9999999)
                this.csObj = res.data
            })
        },
        qualityclose() {
            this.rowObj = {}
            this.qualityvisible = false
        },
        seeImgRecord(row) {
            console.log(this.csObj.orderNo, "this.rowObj")
            this.aisbObj = {}
            this.rowObj = row
            this.imgvisible = true
            _api.queryAIIdentify({ orderNo: this.csObj.orderNo }).then(res => {
                this.currentImg = res.data.exImages || [];
                this.loadImage();
                this.resultData = res.data.exImages
                this.aisbObj = res.data
            })
        },
        rgTypechange(e) {
            if (e == 'right') {
                console.log(this.aisbObj, "反对哈哈")
                this.currentImg = this.aisbObj.images || [];
                this.loadImage();
                console.log(this.currentImg, "this.currentImg;切换之后")
                this.resultData = this.aisbObj.images || []
            } else if (e == 'error') {
                this.currentImg = this.aisbObj.exImages || [];
                this.loadImage();
                this.resultData = this.aisbObj.exImages || []
            }
            else if (e == 'fault') {
                this.currentImg = this.aisbObj.errorImages || [];
                this.loadImage();
                this.resultData = this.aisbObj.errorImages || []
            }
            else if (e == 'no') {
                console.log(4)
                this.currentImg = this.aisbObj.noImages || [];
                this.loadImage();
                this.resultData = this.aisbObj.noImages || []
            }
        },
        copy(e) {
            const spanText = document.getElementById(e).innerText;
            const oInput = document.createElement("input");
            oInput.value = spanText;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            oInput.className = "oInput";
            oInput.style.display = "none";
            document.body.removeChild(oInput);
            this.$message.success("复制成功");
        },
        seeBaojia(row) {
            this.bjObj = {}
            this.reportDialog = true
            _api.zdautoQuoteInfo({ orderNo: row.orderNo, merchantId: row.id }).then(res => {
                console.log(res, 999999)
                this.bjObj = res.data
            })
        },
        loadImage() {
            this.currentImg.forEach((item, index) => {
                const img = new Image();
                img.onload = () => {
                    item.image = img;
                    this.$nextTick(() => {
                        this.drawImage(index);
                    })
                };
                img.src = item.imageUrl;
            })

        },
        drawImage(index) {
            console.log(this.resultData, "this.resultData")
            console.log(index, "99999999999")
            const canvas = document.getElementById(`canvas-${index}`);
            console.log(canvas, "的高度过高")
            const readImage = this.$refs.readImage;
            const ctx = canvas.getContext('2d');
            // 设置 canvas 的实际显示尺寸（根据你的需求设置）
            const containerWidth = 126; // 容器宽度
            const containerHeight = 222; // 容器高度
            // 设置 canvas 的样式尺寸
            canvas.style.width = `${containerWidth}px`;
            canvas.style.height = `${containerHeight}px`;

            // 设置 canvas 的像素尺寸（解决高清屏模糊问题）
            const scale = window.devicePixelRatio || 1;
            canvas.width = containerWidth * scale;
            canvas.height = containerHeight * scale;
            ctx.scale(scale, scale);
            console.log('图片原尺寸宽：', this.currentImg[index].image.width);
            console.log('图片原尺寸高：', this.currentImg[index].image.height);
            // 计算保持原图比例的绘制尺寸
            const imgRatio = this.currentImg[index].image.width / this.currentImg[index].image.height;
            const canvasRatio = containerWidth / containerHeight;
            let drawWidth, drawHeight, offsetX = 0, offsetY = 0;
            if (imgRatio > canvasRatio) {
                // 图片比 canvas 更宽
                drawWidth = containerWidth;
                drawHeight = containerWidth / imgRatio;
                offsetY = (containerHeight - drawHeight) / 2;
            } else {
                // 图片比 canvas 更高或比例相同
                drawHeight = containerHeight;
                drawWidth = containerHeight * imgRatio;
                offsetX = (containerWidth - drawWidth) / 2;
            }
            // 清除画布
            ctx.clearRect(0, 0, containerWidth, containerHeight);
            // 绘制图片
            ctx.drawImage(this.currentImg[index].image, offsetX, offsetY, drawWidth, drawHeight);


            // 绘制结果框
            // 遍历每个item的所有location
            this.currentImg[index].tags.forEach(item => {
                console.log(item, "999")
                item.positions.forEach(item1 => {
                    console.log(item1, '777777')
                    // 计算实际绘制位置（考虑图片缩放和偏移）
                    const scaleX = drawWidth / this.currentImg[index].image.width;
                    const scaleY = drawHeight / this.currentImg[index].image.height;

                    const boxLeft = offsetX + (parseInt(item1.left) * scaleX);
                    const boxTop = offsetY + (parseInt(item1.top) * scaleY);
                    const boxWidth = parseInt(item1.width) * scaleX;
                    const boxHeight = parseInt(item1.height) * scaleY;

                    // 设置框的样式
                    ctx.strokeStyle = '#1BB3D8';
                    ctx.lineWidth = 2;

                    // 设置背景透明度
                    ctx.fillStyle = 'rgba(27, 179, 216, 0.5)';
                    ctx.fillRect(boxLeft, boxTop, boxWidth, boxHeight);

                    // 绘制矩形框
                    ctx.strokeRect(boxLeft, boxTop, boxWidth, boxHeight);
                })
                // const { width, height, left, top } = location;


            });


        },
        // 验机报告查看
        getFunction(v, outType) {
            console.log(999999)
            this.externalorderType = outType;
            // 显示弹窗
            this.imeiTestProps = {
                ...this.imeiTestProps,
                phoneName: "",
                // 检测项
                tableData: [],
                // 功能情况
                functionList: [],
                // 系统检测结果
                systemTestResult: [],
                // 是否无法检测
                unableDetectionCause: "",
                // 是否系统检测且存在检测结果
                isSystem: false,
                // 其他功能标题显示，原需求模糊，抄详情写
                isOtherTitileShow: false,
                // 其他功能表格 原需求模糊，抄详情写
                isOtherTableShow: false,
                // 是否显示成色
                isFinenessShow: false,
                // 成色数据
                finenessData: [],
                // 旧机照片
                photoArr: [],
                // 系统验机项
                systemTestList: [],
                orderMode: "", //下单模式
                funcDetail: {},
                show: true,
                isLoadding: true,
            };
            _api.getInspectionReport({ orderNo: v }).then((res) => {
                this.detailData = res.data;
                if (res.data.againPhotoRemark) {
                    this.detailData.againPhotoRemark = res.data.againPhotoRemark.split("//")
                } else {
                    this.detailData.againPhotoRemark = []
                }
                this.imeiTestProps.isLoadding = false;
            });
        },
        //自动报价新
        seeNewauto(row, id) {
            this.bjObj = {}
            console.log(row.merchantId, 'row.merchantId')
            this.priceDetail = true
            let obj = {}
            obj.orderNo = row.orderNo
            obj.merchantId = row.recycleMerchantId
            if (id) {
                obj.quoteLogId = id
            }
            _api.autoQuoteInfo(obj).then(res => {
                console.log(res, 99999999)
                this.bjObj = res.data
                console.log(this.bjObj, "this.bjObj")
            })

        },
        // 报价商家弹窗
        openStoreList(e) {
            console.log(e, 99999);
            this.isElderlyMachine = e.isElderlyMachine
            this.baoPricestate = e.state;
            this.merchantName = e.merchantName;
            this.orderNo = e.orderNo;
            this.autoInfoOutType = e.outType;
            this.isShowExpButton = e.isShowExpButton;
            this.storeQueryRow = e
            this.storeLoading = true
            const { orderNo, isMappingQuote, recycleMerchantName, isAutoQuote } = e
            console.log('isMappingQuote', isMappingQuote);

            _api.orderStoreList({
                orderNo,
                isMappingQuote: isMappingQuote,
                recycleMerchantName: recycleMerchantName ? recycleMerchantName : '',
                isAutoQuote
            }).then((res) => {
                if (res.code == 1) {
                    for (const item of res.data) {
                        this.handleData(item);
                    }
                    this.storeList = res.data;
                }
                this.storeLoading = false
            });
            this.toggleSelection();
            this.handleOutConfigColumns();
            this.lownum = e.phoneNum
            this.storeShow = true;
        },
        storeClose() {
            this.$refs.storeFormItemList.clearValidForm();
            this.storeShow = false;
            this.storeList = [];
        },
        // 配置列按钮
        handleConfigColumns() {
            // this.toggleSelection()
            // 配置列数据回显
            _api.findColumns({ tableName: "参与报价回收商" }).then((res) => {
                res.data.forEach((item) => {
                    this.$nextTick(() => {
                        this.configData.find((obj) => {
                            if (obj.prop == item.columnName) {
                                this.$refs.multipleTable.$refs.tableGroup.toggleRowSelection(
                                    obj,
                                    true
                                );
                            }
                        });
                    });
                });
            });
            this.configShow = true;
        },
        storeHandleConfirm(e) {
            console.log(e, 111);
            this.openStoreList({
                ...this.storeQueryRow,
                ...e
            })
        },
        // 列表信息回显
        toggleSelection() {
            this.configRefresh = false;
            _api.findColumns({ tableName: "参与报价回收商" }).then((res) => {
                this.storeColumns = this.middleColumns.filter((item) => {
                    return res.data.some(
                        (obj) =>
                            obj.columnName === item.prop || obj.columnName === item.slotName
                    );
                });
                // 解决问题：点击配置数据时，默认选项，其他什么都不选，直接确定而产生的数据为空的bug
                this.configColumnsArr = this.configData.filter((item) => {
                    return res.data.some((obj) => obj.columnName === item.prop);
                });
                this.configRefresh = true;
            });
        },
        // 外部商家报价
        handleOutConfigColumns() {
            this.quoteOperateLoading = true;
            const params = {
                orderNo: this.orderNo,
            };
            _api.getListQuoteByOrderNoOut(params).then((res) => {
                if (res.code === 1) {
                    this.quotePriceData = res.data.list;
                    (this.outMerchant = {
                        maxMerchantName: res.data.maxMerchantName,
                        maxQuoteSecretPrice: res.data.maxQuoteSecretPrice,
                        quoteCondition: res.data.quoteCondition,
                    }),
                        (this.quoteOperateLoading = false);
                }
            });
        },
        async onQuotePrice() {
            await this.handleOutConfigColumns();
            this.quotePriceShow = true;
        },
        // 所有不为真的第一层数据重置为--
        handleData(param) {
            for (const key in param) {
                if (Object.prototype.toString.call(param[key]) === "[object Object]") {
                    this.handleData(param[key]);
                } else if (
                    (param[key] === null ||
                        param[key] === undefined ||
                        param[key] === "") && key !== 'isMarkImeiPull'   //不处理成--
                ) {
                    param[key] = "--";
                }
            }
            return param;
        },
        // 确定
        handleConfig() {
            const transformedArr = this.configColumnsArr.map((obj) => {
                return {
                    columnName: obj.prop, // 将prop属性值赋给columnName属性
                };
            });
            _api
                .configColumns({ tableName: "参与报价回收商", columns: transformedArr })
                .then((res) => {
                    console.log("配置", res);
                    if (res.code == 1) {
                        this.toggleSelection();
                        this.configShow = false;
                    }
                });
        },
        handleSelectionChange(row) {
            this.configColumnsArr = [...row];
        },
        // 重置配置列
        cancelConfig() {
            this.$refs.multipleTable.clearSelection();
            this.configColumnsArr = [];
        },
        openQuoteInfo(row) {
            this.amountDetailDiaShow = true
            this.amountDetailDiaType = row.isQuoterQuick === true ? '01' : '02'
            this.rowItemMerchantId = row.recycleMerchantId
            this.isExamineQuote1 = row.isExamineQuote
            this.isQuoterQuick1 = row.isQuoterQuick
            console.log(this.isExamineQuote1, "isExamineQuote1")
            console.log(this.isQuoterQuick1, "isQuoterQuick1")
            this.orderNo = row.orderNo
            //2.5.3 如果是参考报价
            //if(){
            //this.referenceQuotationDetail=true
            // }

        },
        //查看功能机老年机
        seeLowDetail(row) {
            console.log(row, "row")
            this.lowInfoVisibleDetail = true
            this.lowinfo = row.originalQuotePrice
            this.lowprice = Math.round((row.originalQuotePrice / this.lownum) * row.originalQuotePrice) / row.originalQuotePrice;
        },
        //新增查看自动报价明细
        seeAutoQuoteDetail(row) {
            this.autoInfoDiaDetailLoading = true
            console.log(row, "row")
            this.orderLowView = row.orderLowView || {}
            this.autoInfoDiaDetailLoading = false
            this.autoInfoVisibleDetail = true
        },
        seeAutoQuote() {
            this.autoInfoDiaLoading = true
            _api.getOrderAutoInfo({ orderNo: this.orderNo }).then(res => {
                if (res.code === 1) {
                    this.orderAutoInfo = res.data || {}
                    this.autoInfoDiaLoading = false
                }
            })
            this.autoInfoVisible = true
        },
        Bargain(row, column, cell, event) {
            console.log("@44@", row, column, cell, event);
            if (
                !(row.quoteNum == 0) &&
                !(row.quoteNum == "--") &&
                (column.property == "quoteNum" || column == "config")
            ) {
                console.log(row, "------------");
                // this.storeShow = false;
                this.viewrecords = true;
                _api
                    .getUpdatedQuoteLog({
                        merchantId: row.recycleMerchantId,
                        orderNo: row.orderNo,
                    })
                    .then((res) => {
                        console.log(res.data, "报价信息");
                        this.getUpdatedQuoteLog = res.data.normal;
                        this.remakeQuoteLog = res.data.remake;
                    });
            }
        },
        viewrecordsClose() {
            this.Closingoffer = false;
            this.viewrecords = false;
            this.pricePushshow = false;
        },
        seeDetail(item) {

            let routeData = this.$router.resolve({
                path: "/RecallOrder/imageRecog",
                query: { type: "edit", obj: JSON.stringify(item) },
            });
            window.open(routeData.href, "_blank");
        },
        seekjimgResult(row) {
            this.kjrgType = 'yes'
            this.kjaisbObj = {}
            this.kjimgvisible = true
            this.rowObj = row
            let merchantId = this.$route.query.id
            _api.screeninfo({ orderNo: row.orderNo, merchantId }).then(res => {
                console.log(res.data, 9999)
                this.kjaisbObj = res.data
                this.currentscreenImg = this.kjaisbObj.lightScreenImages || [];
                this.loadscreenImage();
                this.resultscreenData = this.kjaisbObj.lightScreenImages || []
            })
        },
        kjimgclose() {
            this.rowObj = {}
            this.kjimgvisible = false
            this.kjaisbObj = {}
        },
        screenphotochange(e) {
            if (e == 'yes') {
                console.log(1)
                console.log(this.aisbObj, "反对哈哈")
                this.currentscreenImg = this.kjaisbObj.lightScreenImages || [];
                this.loadscreenImage();
                console.log(this.currentImg, "this.currentImg;切换之后")
                this.resultscreenData = this.kjaisbObj.lightScreenImages || []
            } else if (e == 'no') {
                console.log(2)
                this.currentscreenImg = this.kjaisbObj.notLightScreenImages || [];
                this.loadscreenImage();
                this.resultscreenData = this.kjaisbObj.notLightScreenImages || []
            }
            else if (e == 'fault') {
                console.log(3)
                this.currentscreenImg = this.kjaisbObj.errorImages || [];
                this.loadscreenImage();
                this.resultscreenData = this.kjaisbObj.errorImages || []
            }
        },
        loadscreenImage() {
            this.currentscreenImg.forEach((item, index) => {
                console.log(index, "index")
                const img = new Image();
                img.onload = () => {
                    item.image = img;
                    this.$nextTick(() => {
                        this.drawscreenImage(index);
                    })
                };
                img.src = item.imageUrl;
            })

        },
        drawscreenImage(index) {
            const canvas = document.getElementById(`myscreenCanvas-${index}`);
            console.log(canvas, "canvas纷纷改行和")
            const readImage = this.$refs.readImage;
            const ctx = canvas.getContext('2d');
            // 设置 canvas 的实际显示尺寸（根据你的需求设置）
            const containerWidth = 126; // 容器宽度
            const containerHeight = 222; // 容器高度
            // 设置 canvas 的样式尺寸
            canvas.style.width = `${containerWidth}px`;
            canvas.style.height = `${containerHeight}px`;

            // 设置 canvas 的像素尺寸（解决高清屏模糊问题）
            const scale = window.devicePixelRatio || 1;
            canvas.width = containerWidth * scale;
            canvas.height = containerHeight * scale;
            ctx.scale(scale, scale);
            // 计算保持原图比例的绘制尺寸
            const imgRatio = this.currentscreenImg[index].image.width / this.currentscreenImg[index].image.height;
            const canvasRatio = containerWidth / containerHeight;
            let drawWidth, drawHeight, offsetX = 0, offsetY = 0;
            if (imgRatio > canvasRatio) {
                // 图片比 canvas 更宽
                drawWidth = containerWidth;
                drawHeight = containerWidth / imgRatio;
                offsetY = (containerHeight - drawHeight) / 2;
            } else {
                // 图片比 canvas 更高或比例相同
                drawHeight = containerHeight;
                drawWidth = containerHeight * imgRatio;
                offsetX = (containerWidth - drawWidth) / 2;
            }
            // 清除画布
            ctx.clearRect(0, 0, containerWidth, containerHeight);
            // 绘制图片
            ctx.drawImage(this.currentscreenImg[index].image, offsetX, offsetY, drawWidth, drawHeight);
        },
    }
};
</script>
<style scoped lang="scss" ref="stylesheet/scss">
.OrderTable {
    background: white;

    .top_bar {
        background: white;
        display: flex;
        justify-content: space-between;

        .case {
            display: flex;
            align-items: center;
            justify-content: space-between;
            align-items: center;

            .case-title {
                display: flex;

                .case-title_icon {
                    width: 20px;
                    height: 20px;
                }

                .case-title_max {
                    font-weight: bold;
                    color: #333333;
                    font-size: 18px;
                    // width: 80px;
                    height: 17px;
                    line-height: 17px;
                    margin-left: 5px;
                    font-family: FZLanTingHei-B-GBK;
                }
            }
        }
    }

    .orderPagina {
        float: right;
        margin: 50px;
    }

    .order_list {
        .line_top {
            background-color: white;
            width: 100%;
            height: 10px;
        }

        .table_title {
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: space-between;

            .left {
                flex: 1;
                display: flex;
                position: relative;
                align-items: center;

                // justify-content: space-between;
                div {
                    margin-left: 30px;

                    >div {
                        margin-left: 0;
                        width: 32px;
                        height: 22px;
                        background: #21d8c2;
                        border-radius: 3px 11px 11px 3px;
                        color: white;
                        line-height: 22px;
                        position: absolute;
                        text-align: center;
                        top: 0;
                        left: -5px;
                        margin-right: 10px;
                    }

                    >span {
                        font-family: FZLanTingHei-DB-GBK;
                        font-size: 14px;
                        font-weight: 400;
                        color: #0981ff;
                    }

                    >input {
                        border: none;
                        background: none;
                        color: #0981ff;
                        padding: 0;
                        width: 140px !important;
                        font-size: 14px;
                    }

                    >.copy {
                        width: 36px;
                        height: 16px;
                        display: inline-block;
                        line-height: 16px;
                        text-align: center;
                        background: #ff6600;
                        color: #fff;
                        margin-left: 8px;
                        border-radius: 4px;
                        font-size: 12px;
                        cursor: pointer;
                    }
                }
            }

            .right {
                font-size: 14px;
                display: flex;
                color: #fff;

                .rightTrue {
                    width: max-content;
                    padding: 5px 10px;
                    font-size: 14px;
                    background-color: #ff687b;
                    margin-right: 10px;
                    border-radius: 5px;
                    text-align: center;
                }

                .rightFalse {
                    width: max-content;
                    padding: 5px 10px;
                    font-size: 14px;
                    background-color: #ffaf29;
                    margin-right: 10px;
                    border-radius: 5px;
                    text-align: center;
                }

                .rightFalseline {
                    width: max-content;
                    padding: 5px 10px;
                    border: 1px solid #ff687b;
                    border-radius: 14px !important;
                    margin-right: 10px;
                    text-align: center;
                    font-size: 12px;
                    font-family: FZLanTingHei-DB-GBK;
                    font-weight: 400;
                    color: #ff687b;
                }

                .blueFalseline {
                    width: max-content;
                    padding: 5px 10px;
                    border: 1px solid #4c84ff;
                    border-radius: 14px !important;
                    margin-right: 10px;
                    text-align: center;
                    font-size: 12px;
                    font-family: FZLanTingHei-DB-GBK;
                    font-weight: 400;
                    color: #4c84ff;
                }

                .rightMid {
                    width: max-content;
                    padding: 5px 10px;
                    font-size: 14px;
                    background-color: rgba(102, 204, 153, 1);
                    margin-right: 10px;
                    border-radius: 5px;
                    text-align: center;
                }
            }
        }
    }
}

.emptyStyle {
    width: 100%;
    text-align: center;
    padding: 80px 0;
    font-size: 24px;
    color: #666666;
    background: white;
    font-weight: bold;
}

// 弹窗
.img-box {
    margin-bottom: 20px;

    // 图片
    .imgs-num {
        text-align: center;
        margin: 5px 0;
        font-weight: bold;
    }

    .img-tips-box {
        display: flex;
        height: 30px;
        width: max-content;
        border: 1px solid #0981ff;

        .img-tips {
            width: 80px;
            text-align: center;
            line-height: 30px;
            box-sizing: border-box;
            cursor: pointer;
        }

        .img-tips-default {
            background: #fff;
            color: #0981ff;
        }

        .img-tips-choose {
            background: #0981ff;
            color: #fff;
        }
    }

    // 列表
}

.title {
    display: flex;
    line-height: 1em;
    margin-bottom: 20px;

    &::before {
        content: '';
        background: #0981ff;
        margin-right: 10px;
    }
}

.text-down {
    color: #0981ff;
    cursor: pointer;
    text-decoration: underline;
}

.images-box {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.images-box>img {
    width: 70px;
    height: 70px;
    margin-bottom: 10px;
}

.images-box>span {
    color: #0981ff;
    cursor: pointer;
}

.cance-tip {
    color: #ff8080;
    font-size: 14px;
    margin-bottom: 20px;

    .tip-sure {
        margin-top: 10px;
        color: #333333;
        font-size: 16px;
        text-align: center;
    }
}

.command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.img_box {
    max-height: 648px;
    /* 设置你需要的最大高度 */
    overflow-y: auto;

    .read_image {
        position: relative;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        // padding-top: 38px;

        .primary-img {
            position: relative;
            width: 326px;
            height: 249px;
            border-radius: 6px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            background: #E4ECFD;
            border-radius: 6px;
            padding: 12px;

            img {
                width: 100%;
                height: 100%;
            }

            .mask {
                width: 154px;
                height: 185px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 4px;
                border: 1px solid #ffffff;
                position: absolute;
                top: 0px;
                left: 0px;
                z-index: 88;
                cursor: move;
                box-sizing: border-box;
            }
        }

        .img_btn {
            margin-top: 24px;

            img {
                width: 28px;
                height: 28px;
                cursor: pointer;
            }
        }
    }

    .read_image {
        // margin-left: 20px;
    }
}

.labelbox {
    height: 222px;
    width: 167px;
    flex-shrink: 0;
    padding: 10px;
    margin-left: 10px;
}

.noteLayout {
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title-base {
    font-weight: 700;
    font-size: 16px;
    border-left: 1px solid #3399FF;
    padding: 0 10px;
    box-sizing: border-box;
    color: #000;
    display: flex;
    margin-bottom: 20px;
}

.inner {
    padding: 0 10px;
    height: 22px;
    width: auto;
    background: #FFF3F1;
    border-radius: 11px;
    border: 1px solid #F84D33;
    font-weight: 400;
    font-size: 12px;
    color: #F84D33;
    margin-left: 10px;
    line-height: 22px;
}

.liang,
.xiaohua {
    padding: 0 10px;
    height: 22px;
    width: auto;
    background: #F0FFF0;
    border-radius: 11px;
    border: 1px solid #00C003;
    font-weight: 400;
    font-size: 12px;
    color: #00C003;
    margin-left: 10px;
    line-height: 22px;
}

.dahua {
    padding: 0 10px;
    height: 22px;
    width: auto;
    background: #FFF9E4;
    border-radius: 11px;
    border: 1px solid #FFCB00;
    font-weight: 400;
    font-size: 12px;
    color: #FFCB00;
    margin-left: 10px;
    line-height: 22px;
}

.waibao {
    padding: 0 10px;
    height: 22px;
    width: auto;
    background: #FFF6EF;
    border-radius: 11px;
    border: 1px solid #FF822A;
    font-weight: 400;
    font-size: 12px;
    color: #FF822A;
    margin-left: 10px;
    line-height: 22px;
}

.wufa,
.risk {
    padding: 0 10px;
    height: 22px;
    width: auto;
    background: #FCF7F6;
    border-radius: 11px;
    border: 1px solid #BA210A;
    font-weight: 400;
    font-size: 12px;
    color: #BA210A;
    margin-left: 10px;
    line-height: 22px;
}

.auto-info-dia {
    .auto-info-dia-tip {
        font-size: 16px;
        margin-bottom: 10px;

        .general-blue {
            color: #0981FF;
        }

        .general-yellow {
            color: #ffbf54;
        }
    }

    .status_grd {
        color: #909399;
        height: 17px;
        display: flex;
        font-size: 12px;
        align-items: center;
        padding: 0 5px;
        border: 1px solid #909399;
        border-radius: 15px 15px 15px 4px;
        margin-left: 10px;

        &.abnormal {
            color: #ff687b;
            border: 1px solid #ff687b;
        }
    }

    &>p {
        margin: 5px 0;
    }
}

/deep/.mytable1 .el-table__header th {
    height: 40px;
    padding: 0;
}

/deep/.custom-dialog .el-dialog {
    max-height: 648px;
    /* 设置你需要的最大高度 */
    overflow-y: auto;
    /* 允许垂直滚动 */
}

/deep/ .el-radio-button__inner {
    border-radius: 6px;
}

.custom-dialog {}

.myboxtel {
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px 0 10px 10px;
}

.myboxtel:last-child {
    border-bottom: none;
    margin-bottom: 0px;
}

/deep/.el-radio-button {
    border-radius: 6px !important;
    border-left: 1px solid #E4ECFD
}

/deep/ el-radio-button:last-child {
    border-radius: 6px !important;
}

/deep/ el-radio-button:first-child {
    border-radius: 6px !important;
}

/deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 6px !important;
}

/deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 6px !important;
}

.sec_img {
    width: 20vw;
    height: 80vh;
    margin: auto;

    img {
        width: 20vw;
        height: 80vh;
        object-fit: contain;
    }
}

.titlefin {
    display: flex;
    line-height: 1em;
    margin-bottom: 20px;
    border-left: 4px solid #3399FF;

    &::before {
        content: '';
        background: #0981ff;
        margin-right: 10px;
    }
}

/deep/ .el-card.is-always-shadow {
    width: 610px;
}
</style>